const DocumentIcon = ({ className = 'h-6' }) => {
	return (
		<svg
			className={className}
			xmlns="http://www.w3.org/2000/svg"
			width="29"
			height="39"
			viewBox="0 0 29 39"
			fill="none"
		>
			<path
				d="M6.91982 1H26.3634C26.7975 1 27.2137 1.17243 27.5206 1.47934C27.8276 1.78625 28 2.20251 28 2.63655V35.6828C28 35.8978 27.9576 36.1105 27.8754 36.3091C27.7932 36.5076 27.6726 36.6881 27.5206 36.84C27.3687 36.992 27.1883 37.1126 26.9897 37.1948C26.7912 37.2771 26.5783 37.3194 26.3634 37.3194H2.63654C2.42163 37.3194 2.20882 37.2771 2.01027 37.1948C1.81171 37.1126 1.6313 36.992 1.47933 36.84C1.32736 36.6881 1.20682 36.5076 1.12457 36.3091C1.04233 36.1105 1 35.8978 1 35.6828V6.92131C0.999928 6.70601 1.04234 6.49283 1.1248 6.29395C1.20726 6.09507 1.32815 5.91442 1.48055 5.76235L5.76383 1.47907C5.91585 1.32712 6.09631 1.2066 6.29491 1.1244C6.49352 1.04221 6.70637 0.999929 6.92131 1H6.91982Z"
				stroke="#5D9BFD"
				strokeWidth="1.74258"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M1.41864 6.95658H6.59755C6.80707 6.95658 7.00802 6.87333 7.15617 6.72518C7.30433 6.57702 7.38756 6.37608 7.38756 6.16656V1.0293"
				stroke="#5D9BFD"
				strokeWidth="1.74258"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M14.5493 10.3086H23.4997"
				stroke="#5D9BFD"
				strokeWidth="1.74258"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M5.61682 10.3086H11.3626"
				stroke="#5D9BFD"
				strokeWidth="1.74258"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M5.33603 13.9199H17.5878"
				stroke="#5D9BFD"
				strokeWidth="1.74258"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M5.2952 24.751H18.2373"
				stroke="#5D9BFD"
				strokeWidth="1.74258"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M12.0749 21.1396H23.623"
				stroke="#5D9BFD"
				strokeWidth="1.74258"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M5.68658 21.1396H9.06828"
				stroke="#5D9BFD"
				strokeWidth="1.74258"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M6.41663 17.5293H22.5827"
				stroke="#5D9BFD"
				strokeWidth="1.74258"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};

export default DocumentIcon;
